export default __webpack_public_path__ + "2941d320537a8c8f7fe8c93792474587.png";